<template>
  <Popup :show="show">
    <div class="agreement-pop">
      <SvgIcon icon-class="close" class-name="close" @click.native="handleClose"></SvgIcon>
      <div class="agreement-content">
        <p class="agreement-title">{{title}}</p>
        <div class="agreement-explain">
          <slot></slot>
        </div>
        <div class="agreement-footer">
          <Checkbox @input="handleAgree" :value="value" class="checkbox">
            <span>{{checkText}}</span>
          </Checkbox>
          <div
            class="btn"
            :class="value ? 'btn-pass' : 'btn-disabled'"
            @click="handleConfirm"
          >确认</div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup'
import SvgIcon from '@/components/SvgIcon'
import Checkbox from '@/components/Checkbox'
import Bridge from 'lib/lib/Bridge'
import { isApp } from '@/utils/utils'

export default {
  name: 'AgreementPop',
  props: {
    show: Boolean,
    number: Number,
    value: Boolean,
    title: String,
    checkText: String
  },
  components: {
    Popup,
    SvgIcon,
    Checkbox
  },
  created () {
    if (isApp()) {
      this.$watch('show', function (show) {
        new Bridge().call('isPullRefreshEnable', {
          enable: Number(!show)
        })
      }, {
        immediate: true
      })
    }
  },
  methods: {
    handleAgree (value) {
      this.$emit('input', value)
    },
    handleConfirm () {
      if (this.value) {
        this.$emit('confirm', true)
      } else {
        this.$toast('请购选同意协议')
      }
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement-pop {
  background: #fff;
  border-radius: 30px;
  width: 600px;
  padding-top: 60px;
  position: relative;
  .close {
    position: absolute;
    top: 25px;
    right: 25px;
    font-size: 28px;
  }
  .agreement-content {
    .agreement-title {
      text-align: center;
      font-size: 36px;
      margin-bottom: 30px;
    }
    .agreement-explain {
      height: 50vh;
      overflow-y: auto;
      padding: 0 35px;
    }
    .agreement-footer {
      height: 85px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .checkbox {
        display: flex;
        align-items: center;
        margin-left: 20px;
        span {
          font-family: PingFangSC-Regular;
          font-size: 26px;
          color: #7C8790;
          margin-left: 20px;
        }
      }
      .btn {
        height: 100%;
        width: 160px;
        border-radius: 0 0 30px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 30px;
        &.btn-pass {
          background: #6982fa;
        }
        &.btn-disabled {
          background: #909399;
        }
      }
    }
  }
}
</style>
